import React, { useEffect } from "react";
import Translate from "../components/Translate";
import { Link } from "react-router-dom";
import { FaSitemap, FaHome } from "react-icons/fa";

import { useTranslation } from "react-i18next";
import { updateMetaTags } from "../utils/seo";
import PageBanner from "../components/PageBanner";

export default function Sitemap() {
    const { t, i18n } = useTranslation();
    useEffect(() => {
        updateMetaTags(
            `${t('sitemap')} | ${t('site-title')}`,
            t('sitemap-desc'),
            t('sitemap-keywords')
        );
    }, [t, i18n.language]);

    const sitemapLinks = [
        { title: <Translate text="home" />, path: "/" },
        { title: <Translate text="about_us" />, path: "/about" },
        { title: <Translate text="announcements" />, path: "/all-announcements" },
        { title: <Translate text="archive" />, path: "/archive" },
        { title: <Translate text="sales-points" />, path: "/sales-points" },
        { title: <Translate text="rti" />, path: "/rti" },
        { title: <Translate text="advertisements" />, path: "/advertisements" },
        { title: <Translate text="contact-us" />, path: "/contact" },
        { title: <Translate text="grievance" />, path: "/grievance" },
        { title: <Translate text="e-employment-news-subscription" />, path: "/e-employment-news-subscription" },
        { title: <Translate text="print-employment-news-subscription" />, path: "/print-employment-news-subscription" },
    ];

    const policyLinks = [
        { title: <Translate text="privacy_policy" />, path: "/policies/privacy" },
        { title: <Translate text="hyperlinking_policy" />, path: "/policies/hyperlinking" },
        { title: <Translate text="copyright_policy" />, path: "/policies/copyright" },
        { title: <Translate text="terms_conditions" />, path: "/policies/terms" },
        { title: <Translate text="website_monitoring_plan" />, path: "/policies/monitoring-plan" },
        { title: <Translate text="contingency_management_plan" />, path: "/policies/contingency-plan" },
        { title: <Translate text="accessibility_statement" />, path: "/accessibility-statement" },
        { title: <Translate text="help" />, path: "/help" },
    ];

    return (
        <section className="w-full min-h-screen bg-gray-50 pb-16">
            <PageBanner
                title={<Translate text="sitemap" />}
                subtitle={<Translate text="sitemap-subtitle" />}
                badgeText={t('badge-portal-directory')}
            />

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                    {/* Main Navigation links */}
                    <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
                        <h2 className="text-2xl font-bold text-primary-800 mb-6 flex items-center gap-2">
                            <div className="w-2 h-8 bg-primary-600 rounded-full"></div>
                            <Translate text="main_sections" />
                        </h2>
                        <ul className="space-y-4">
                            {sitemapLinks.map((link, index) => (
                                <li key={index}>
                                    <Link
                                        to={link.path}
                                        className="text-gray-700 hover:text-primary-600 font-medium flex items-center gap-3 group transition-colors"
                                    >
                                        <span className="w-1.5 h-1.5 rounded-full bg-primary-200 group-hover:bg-primary-500 transition-all"></span>
                                        {link.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Policy links */}
                    <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
                        <h2 className="text-2xl font-bold text-primary-800 mb-6 flex items-center gap-2">
                            <div className="w-2 h-8 bg-primary-600 rounded-full"></div>
                            <Translate text="policies_help" />
                        </h2>
                        <ul className="space-y-4">
                            {policyLinks.map((link, index) => (
                                <li key={index}>
                                    <Link
                                        to={link.path}
                                        className="text-gray-700 hover:text-primary-600 font-medium flex items-center gap-3 group transition-colors"
                                    >
                                        <span className="w-1.5 h-1.5 rounded-full bg-primary-200 group-hover:bg-primary-500 transition-all"></span>
                                        {link.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
